module.exports = __webpack_public_path__ + "e56398c58fab3cc5bf44acf78d637369.svg";